import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

export const CompanyMailboxLifecyclePayloadSchema = z.object({
  workspaceId: z.uuid(),
  companyMailboxId: z.uuid(),
  actor: ActorSchema,
});
export type CompanyMailboxLifecyclePayload = z.infer<typeof CompanyMailboxLifecyclePayloadSchema>;
